import React from "react";
import Icon from "@ant-design/icons";


const StaffClockSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M23.9,4.9C13.36,4.9,4.79,13.48,4.79,24.01s8.57,19.11,19.11,19.11,19.11-8.57,19.11-19.11S34.44,4.9,23.9,4.9ZM23.9,40.63c-9.16,0-16.61-7.45-16.61-16.61S14.74,7.4,23.9,7.4s16.61,7.45,16.61,16.61-7.45,16.61-16.61,16.61Z"/>
        <path d="M33.69,28.67l-8.7-5.6v-12.37c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v13.06c0,.42.22.82.57,1.05l9.27,5.97c.21.13.44.2.68.2.41,0,.81-.2,1.05-.57.37-.58.21-1.35-.37-1.73Z"/>
    </svg>
);

const StaffClockIcon = (props) => (
    <Icon component={ StaffClockSvg } { ...props } />
);

export default StaffClockIcon;
